import { useStaticQuery, graphql } from "gatsby"
import DropdownNavItem from "@/components/DropdownNavItem"
import NavItem from "@/components/NavItem"
import UserRecognizer from "@/components/UserRecognizer"
import * as styles from "@/styles/modules/UserNavItem.module.scss"

export default function UserNavItem({
  identifier,
  enableDropdowns,
  forceTheme,
}) {
  const data = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          userNavItems {
            emoji
            text
            type
            url
          }
        }
      }
    }
  `)

  const userNavItems =
    data.site?.siteMetadata?.userNavItems?.filter(item => item.text) || []
  return (
    <div className={styles.wrapper}>
      <NavItem
        itemText="My DONUT"
        enableDropdowns={enableDropdowns}
        forceTheme={forceTheme}
        isUserNavItem
        rightAlignDropdown
      >
        {userNavItems.length > 0
          ? userNavItems.map(({ emoji, text, url }, i) => (
              <DropdownNavItem
                key={`${text}${i}`}
                itemText={text}
                emoji={emoji}
                url={url}
              />
            ))
          : null}
        <DropdownNavItem
          itemText="Subscription Preferences"
          url="/subscription-preferences"
        />
        <hr className={styles.divider} />
        <UserRecognizer identifier={identifier} />
      </NavItem>
    </div>
  )
}
